import { render, staticRenderFns } from "./TableInspectMerge.vue?vue&type=template&id=1a8d75d1&scoped=true&"
import script from "./TableInspectMerge.vue?vue&type=script&lang=js&"
export * from "./TableInspectMerge.vue?vue&type=script&lang=js&"
import style0 from "./TableInspectMerge.vue?vue&type=style&index=0&id=1a8d75d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8d75d1",
  null
  
)

export default component.exports